import { getStylePackById } from '@/themes/stylePacks';

/**
 * WEB-926 позиция 4: форма промо-тикета берётся из стиль-пака
 * (`paywall.promoTicket`), как формат таймера в WEB-925 атом 4.
 *
 * `'none'` НЕ означает «пак убирает тикет»: блок ставит автор руками, пак
 * отвечает за форму, а не за наличие. Поэтому 'none' (и отсутствие пака, и
 * выдуманный id) резолвится в 'plain' — нейтральная плашка без перфорации.
 */
export type PromoTicketShape = 'perforated' | 'plain';

export function resolvePromoTicketShape(stylePackId?: string): PromoTicketShape {
  const pack = stylePackId ? getStylePackById(stylePackId) : undefined;
  return pack?.paywall.promoTicket === 'perforated' ? 'perforated' : 'plain';
}
